import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function userListUpdateRequiredReducer(state = initialState.userListUpdateRequired, action) {
    switch (action.type) {
        case types.LOAD_USERS_SUCCESS:
        case types.LOAD_USERS_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_USER_INCOMING:
        case types.UPDATED_USER_SUCCESS:
            return true;
        default:
            return state;
    }
}